import 'bootstrap/dist/css/bootstrap.min.css';
import './css/index.min.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import NavBar from "./Navbar";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
		<React.StrictMode>
			<NavBar/>
			<App/>
		</React.StrictMode>
);